import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { defaultPerPage, setRequestInformationModalOpen } from '../../reducers/communityLandingPageReducer'
import { canContactCommunity } from '../../utility/userHelper'
import SubmitButton from '../common/buttons/SubmitButton'

import classes from './NoProgramsPlaceholder.module.scss'
import { ReactComponent as GolferHalfIcon } from '../../assets/images/common/icons/golfer-half-icon.svg'
import { getCommunityLandingPagePrograms } from '../../actions/programActions'

const NoProgramsPlaceholder = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { otherRegistrationPeriodCoursesCount, filters, community } = useSelector(state => state.communityLandingPage)
  const user = useSelector(state => state.user.current_user)

  const canContact = canContactCommunity(user, community.id)

  const otherRegistrationPeriodFilters = {
    ...filters,
    future: !filters.future,
  }

  return (
    <div className='flex-grow-1 d-flex flex-column align-items-center justify-content-center'>
      <GolferHalfIcon className={classnames('mb-3', classes.icon)} />
      <h2 className={classnames('mb-3', classes.title)}>
        {filters.future
          ? t('communityLanding.noPrograms.titleFuture')
          : t('communityLanding.noPrograms.titleActive')}
      </h2>
      <p className={classnames('mb-3', classes.message)}>
        {otherRegistrationPeriodCoursesCount > 0 ? (
          filters.future
            ? t('communityLanding.noPrograms.otherPeriodAlreadyOpen', { count: otherRegistrationPeriodCoursesCount })
            : t('communityLanding.noPrograms.otherPeriodOpeningSoon', { count: otherRegistrationPeriodCoursesCount })
        ) : (
          canContact
            ? t('communityLanding.noPrograms.checkBackSoon')
            : t('communityLanding.noPrograms.checkBackSoonShort')
        )}
      </p>
      {otherRegistrationPeriodCoursesCount > 0 && (
        <button
          className={classnames('mb-5', classes.viewFuturePrograms)}
          onClick={() => {
            dispatch(getCommunityLandingPagePrograms({
              communityId: community.id,
              filters: otherRegistrationPeriodFilters,
              page: 1,
              perPage: defaultPerPage,
            }))
          }}
        >
          <i className='fa fa-calendar mr-2' />
          {filters.future
            ? t('communityLanding.noPrograms.viewActivePrograms')
            : t('communityLanding.noPrograms.viewFuturePrograms')}
        </button>
      )}
      {canContact && (
        <>
          <p className={classes.message}>
            {t('communityLanding.noPrograms.haveQuestions')}
          </p>
          <SubmitButton
            buttonMessage={t('communityLanding.noPrograms.requestInformation')}
            className='w-fit-content'
            noTopMargin
            onClick={() => dispatch(setRequestInformationModalOpen(true))}
          />
        </>
      )}
    </div>
  )
}

export default NoProgramsPlaceholder
